// extracted by mini-css-extract-plugin
export default {"create":"CreateCatCard_create__iVsDL"};